import React, { useCallback, useState } from 'react';
import { useContentArea } from 'cart-ui';
import { Modal } from 'forms/src';
import './ContentAreaPopupDisplay.scss';
interface Props {
    areaName: string;
}

const ContentAreaPopupDisplay = ({ areaName }: Props) => {
    const content = useContentArea(areaName);
    const [show, setShow] = useState(true);
    const handleClose = useCallback(() => {
        setShow(false);
    }, []);
    return content ?
        <Modal
            show={show}
            onClose={handleClose}
            className="ContentAreaPopupDisplay-modal"  // was pws-popup-modal
            backdropClassName="ContentAreaPopupDisplay-modal-backdrop" // was pws-popup-modal-backdrop
        >
            <div
                className={`content-area content-area-${areaName}`}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </Modal> :
        <></>;
};

export default ContentAreaPopupDisplay;
